const actions = {
  401: () => {
    alert('Ops! Parece que você está desconectado! Faça login e tente novamente.');

    window.location.reload();
  }
};

const humanize = (axios) => {
  axios.interceptors.response.use((response) => {
    return response;
  }, (error) => {
      if (error.response) {
        const action = actions[error.response.status];

        if (action) {
          return action(error);
        }
      }

      return Promise.reject(error);
  });
};

export default humanize;
